module.exports = __webpack_public_path__ + "img/mail_post.7a8c0eeb.png";